import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SubTask } from '../../client/generated/graphql';
import { RitualConfig } from '../../helpers/ritual';
import { RitualPageTaskItem } from './RitualPageTaskItem';

interface RitualTasksListProps {
    tasks: SubTask[];
    config: RitualConfig;
    onToggle: (index: number) => void;
    onAction: (index: number) => void;
}

export const RitualTasksList: FC<RitualTasksListProps> = ({ tasks, config, onToggle, onAction }) => {
    const { t } = useTranslation();
    return (
        <Stack sx={{ flex: 1, overflow: 'auto', padding: '0 16px' }}>
            <Text style={{ fontSize: '13px', fontWeight: 600, color: 'var(--tgui--hint_color)', paddingBottom: '10px' }}>
                {t('ritual.today')}
            </Text>
            <Box sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
                <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                    {tasks.map((task, index) => (
                        <RitualPageTaskItem
                            key={index}
                            task={task}
                            index={index}
                            config={config}
                            showDivider={index > 0}
                            onToggle={onToggle}
                            onAction={onAction}
                        />
                    ))}
                </Box>
            </Box>
        </Stack>
    );
};
